import { UPDATE_FRONT_STYLE_SPARKED_COCO } from "./frontStyleSparkedCocoReducer"

export const updateFrontStyleSparkedCoco = (status) => ({
    type: UPDATE_FRONT_STYLE_SPARKED_COCO,
    payload: status
})
